import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Card, CircularProgress, Grid, FormControlLabel, Checkbox  } from '@mui/material';
import { useSelector } from 'react-redux';
import axios from 'axios';

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

function CreateTickets() {
  const auth = localStorage.getItem("authToken"); 
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [values, setValues] = useState({ title: '', description: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // Get the user ID from the Redux store
  const user_id = useSelector((s) => s.user.userData.user_id);
  const admin = useSelector((s) => s.user.userData.role) === 'admin';
  
  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleFileSelect = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!values.title || !values.description) {
      enqueueSnackbar('Please Provide All The Details !!!', { variant: 'error' });
      return;
    }

    setLoading(true);

    const requestData = new FormData();
    requestData.append('issue_title', values.title);
    requestData.append('issue_description', values.description);
    requestData.append('supporting_doc_url', selectedFile);
    requestData.append('status', 0);
    requestData.append('user_id', user_id); 
    requestData.append('chat', "Welcome to chat on the ticket enquiry!!!");
    requestData.append('is_admin', admin ? 1 : 0);

    // Make the POST request to the backend
    await axios
      .post(`${process.env.REACT_APP_BASEURL}/admin/ticket/add`, requestData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          enqueueSnackbar('Ticket generated successfully', { variant: 'success' });
          navigate('/tickets');
        } else {
          enqueueSnackbar('Failed to generate ticket', { variant: 'error' });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar('Error occurred while creating the ticket. Please try again.', { variant: 'error' });
        setLoading(false);
      });
  };

  const handleAdminCheckboxChange = (e) => {
    setIsAdmin(e.target.checked);
  };
  
  return (
    <DashboardLayout>
      <DashboardNavbar hidebreadcrumbTitle />

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Create Ticket
                </MDTypography>
              </MDBox>

              <MDBox p={3} component="form" role="form">
                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Title"
                    value={values.title}
                    name="title"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="text"
                    label="Description"
                    value={values.description}
                    name="description"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="file"
                    margin="dense"
                    fullWidth
                    onChange={handleFileSelect}
                  />
                </MDBox>
              
                <Grid container direction="row" justifyContent="flex-end" p={2} pb={0.5}>
                  <MDButton variant="gradient" color="info" onClick={handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={20} sx={{ color: 'inherit' }} /> : 'Add Ticket'}
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CreateTickets;